<!-- start app-failure -->
<div class="failure d-flex align-items-center justify-content-center">
    <div @fied  class="wrap">
        <div class="custom_icon"></div>
        <p class="text_md_bold">{{msg}}</p>
        <app-btn [title]="titleBtn" (click)="submit()"></app-btn>
    </div>
</div>
<!-- end app-failure -->